import QRCode from 'react-qr-code';
import PlayList from './components/PlayList';
import { useDisplayConnection } from './hooks/useDisplayConnection';
import { CONFIGURATION_URL } from './config';
import { SignyLogo } from './components/SignyLogo';
import { StatusScreen } from './components/StatusScreen';

function App() {
  const { connection, playlist, hubstate, blockedMessage } = useDisplayConnection();

  if (!connection) {
    if (blockedMessage) {
      return <StatusScreen state="blocked" message={blockedMessage} />;
    }

    // The offline message used to be gated on `navigator.onLine`, so it was
    // hidden in the one situation it described: a panel that is genuinely
    // offline rendered the logo and no text whatsoever. That is the blank
    // white screen customers report, and it was showing nothing precisely
    // when it had the most to say.
    return (
      <StatusScreen
        state={navigator.onLine ? 'connecting' : 'offline'}
        message={
          navigator.onLine
            ? 'Ansluter...'
            : 'Skärmen är inte ansluten till internet. Kontrollera nätverkskabeln eller wifi.'
        }
      />
    );
  }

  if (connection.deviceId && !connection?.displayId) {
    return (
      <div className="flex h-screen w-full flex-col items-center justify-center space-y-12 bg-white">
        <div className="w-[300px]">
          <SignyLogo />
        </div>
        <QRCode value={`${CONFIGURATION_URL}/${connection.deviceId}`} />
        <p className="w-1/2 text-center text-lg font-semibold">
          Skanna QR-koden med din mobiltelefon för att konfigurera skärmen. Om du inte har en QR-läsare kan du öppna följande länk i din webbläsare:
          <br />
          {`${CONFIGURATION_URL}/${connection.deviceId}`}
        </p>
      </div>
    );
  }

  if (playlist) {
    return <PlayList playlist={playlist} />;
  }

  // Connected to the hub, but nothing to play. Three genuinely different
  // situations that all used to look identical from the doorway.
  const state = !navigator.onLine
    ? 'offline'
    : hubstate.connected
      ? 'no-playlist'
      : 'connecting';

  const messages: Record<string, string> = {
    offline: 'Skärmen är inte ansluten till internet. Kontrollera nätverkskabeln eller wifi.',
    'no-playlist': 'Ingen spellista är vald att spelas på denna skärm.',
    connecting: 'Ansluter...',
  };

  return (
    <StatusScreen
      state={state}
      message={messages[state]}
      deviceId={connection.deviceId}
      displayId={connection.displayId}
      venueId={connection.venueId}
    />
  );
}

export default App;
